import React from 'react';
import {loadLanguage} from 'Utils/jwtUtil';
import BasicButton from 'Components/common/BasicButton';
import util from 'Utils/commonUtil';

// Actions
import {T} from 'Actions/translate';

class showShippingPlanModal extends React.Component {
    isTodayRender = (currentDate) => {
        const today = new Date();
        const targetDate = new Date(currentDate);
        let isRenderColor = false;

        if (targetDate <= today) {
            isRenderColor = true;
        } else {
            isRenderColor = false;
        }

        return isRenderColor;
    };

    render() {
        const {item} = this.props;

        console.log('item.shippingPlan==============', item.shippingPlan);
        return (
            item.shippingPlan &&
            item.shippingPlan.length > 0 && (
                <div className="shipment-plan-container">
                    <div className="shipment-plan-label">
                        {T('shipping_plan')}:{' '}
                    </div>
                    {item.shippingPlan.map((planItem, planIndex) => (
                        <div className="shipment-plan-value">
                            <div
                                className={
                                    this.isTodayRender(planItem.shippingDate)
                                        ? 'date red-color'
                                        : 'date'
                                }>
                                {planItem.shippingDate}
                            </div>
                            <div
                                className={
                                    this.isTodayRender(planItem.shippingDate)
                                        ? 'quantity red-color'
                                        : 'quantity'
                                }>
                                {' '}
                                {T('shipping_plan_shipping')}
                                {planItem.quantity}
                                {T('shipping_plan_shipping_unit')}
                            </div>
                            <div
                                className="complete-shipping-plan-btn"
                                onClick={() =>
                                    this.props.completedShippingPlanHandle(
                                        planItem.id,
                                    )
                                }>
                                <label
                                    className={
                                        typeof planItem.markComplete !==
                                            'undefined' && planItem.markComplete
                                            ? 'mark-complete-shipping-plan'
                                            : ''
                                    }>
                                    {T('shipping_plan_complete')}
                                </label>
                                {typeof planItem.markComplete !== 'undefined' &&
                                planItem.markComplete
                                    ? null
                                    : T('shipping_plan_complete_suffix')}
                            </div>
                            {/* <BasicButton
                                type="primary"
                                className="complete-shipping-plan-btn"
                                onClickOfSingleTap={() =>
                                    this.props.completedShippingPlanHandle(
                                        planItem.id,
                                    )
                                }>
                                {T('shipping_plan_complete')}
                            </BasicButton> */}
                        </div>
                    ))}
                </div>
            )
        );
    }
}

export default showShippingPlanModal;
